'use client';

import { useTranslations } from 'next-intl';
import { Link } from '@/lib/i18n/routing';
import WhatsAppButton from '@/components/whatsapp-button';
import CookieConsent from '@/components/cookie-consent';
import { PRODUCTS, BRANDS, type BrandSlug } from '@/lib/products';

const FOOTER_BRANDS: BrandSlug[] = ['wacker-neuson', 'hyundai-everdigm'];

export default function PublicFooter() {
  const t = useTranslations('publicFooter');

  return (
    <>
      <WhatsAppButton />
      <CookieConsent />
      <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          {/* Brand */}
          <div className="footer-brand">
            <span className="logo-text">GOLDMAN <span>INDUSTRIAL</span></span>
            <p>{t('tagline')}</p>
            <p style={{ marginTop: '0.5rem' }}>
              <a href="mailto:info@gis.gy" style={{ color: 'var(--orange-primary)' }}>info@gis.gy</a> | +592 763-8844
            </p>
          </div>

          {/* Quick Links */}
          <div className="footer-links">
            <h4>{t('quickLinks.title')}</h4>
            <ul>
              <li><Link href="/#about">{t('quickLinks.about')}</Link></li>
              <li><Link href="/#equipment">{t('quickLinks.equipment')}</Link></li>
              <li><Link href="/#services">{t('quickLinks.services')}</Link></li>
              <li><Link href="/#contact">{t('quickLinks.contact')}</Link></li>
            </ul>
          </div>

          {/* Equipment — one column per brand, data-driven from lib/products.ts */}
          {FOOTER_BRANDS.map((slug) => (
            <div className="footer-links" key={slug}>
              <h4>
                <Link href={BRANDS[slug].href} style={{ color: 'inherit', textDecoration: 'none' }}>
                  {BRANDS[slug].name}
                </Link>
              </h4>
              <ul>
                {PRODUCTS[slug].map((p) => (
                  <li key={`${slug}/${p.slug}`}>
                    <Link href={`/equipment/${slug}/${p.slug}`}>{p.shortName}</Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          {/* Contact */}
          <div className="footer-links">
            <h4>Contact</h4>
            <ul>
              <li><a href="tel:+5927638844">+592 763-8844</a></li>
              <li><a href="https://wa.me/5927638844" target="_blank" rel="noopener noreferrer">WhatsApp</a></li>
              <li><a href="mailto:info@gis.gy">info@gis.gy</a></li>
              <li>Lot 318 East Street,<br />North Cummingsburg, Georgetown</li>
              <li>Mon-Sat: 7:00 AM-5:00 PM</li>
            </ul>
          </div>

          {/* Legal */}
          <div className="footer-links">
            <h4>{t('legal.title')}</h4>
            <ul>
              <li><Link href="/privacy">{t('legal.privacy')}</Link></li>
              <li><Link href="/terms">{t('legal.terms')}</Link></li>
              <li><Link href="/cookies">{t('legal.cookies')}</Link></li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="footer-bottom">
          <p>{t('copyright')}</p>
          <p className="footer-company-info">{t('companyInfo')}</p>
          <p>{t('servingGuyana')}</p>
        </div>
      </div>
    </footer>
    </>
  );
}
